<template>
    <div class="grid p-fluid">
        <Toast/>
        <!-- Aviso fijo mientras Contablus espera al SRI (ver service/sriPendingToast.js) -->
        <Toast group="sriPending"/>
        <div class="col-12">
            <div class="card" :style="{'background-color':this.cardBackgroundColor}">
                <div style="width: 100%; display: flex;">
                    <h2 style="font-size: large;">Nota de Crédito - {{ this.$store.getters.defaultActivity.name }}</h2>
                </div>
                <div class="grid formgrid" style="margin-top: 0px;" v-show="this.sale.id !== null">
                    <div class="col-12">
                        <div class="card">
                            <h5 style="margin-bottom: 25px;"><b>Factura {{ (this.sale.id !== null) ? " N: " + this.sale.serialNumber : this.creditNote.saleSerialNumber }}</b></h5>
                            <!-- A consumidor final el SRI no admite notas de credito. El backend
                                 rechaza igual (finalConsumerCreditNoteError); esto avisa antes
                                 de que el usuario llene la nota. -->
                            <div v-if="saleBlocksCreditNote" class="flex align-items-start mb-3 p-3"
                                 style="background-color: var(--red-50); border-left: 4px solid var(--red-500); border-radius: 4px;">
                                <i class="pi pi-ban mr-2 mt-1" style="color: var(--red-700)" />
                                <span style="font-size: 0.9rem;">Esta factura se emitió a <strong>CONSUMIDOR FINAL</strong>. El SRI no admite notas de crédito sobre ella.</span>
                            </div>
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-6">
                                    <div style="display: flex;">
                                        <label style="font-weight: bold; text-align: left;">Cliente:</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.id !== null) ? this.sale.customer.name : "CONSUMIDOR FINAL" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Céd/RUC/Pasaporte:</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.id !== null) ? this.sale.customer.identification : "9999999999" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Dirección</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.id !== null) ? this.sale.customer.address : "-" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Correo</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.email !== null) ? this.sale.customer.email : "-" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Teléfono</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.customer.id !== null) ? this.sale.customer.phone : "9999999999" }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Fecha Emisión</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ (this.sale.id !== null) ? this.sale.createdAt.toLocaleDateString("es-ES") : "" }}</label>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-6 saleInformationContainer">
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Subtotal 0%</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.sub0 ? this.sale.sub0.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Subtotal 5%</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.sub5 ? this.sale.sub5.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">{{ this.sale.subGeneralLabel }}</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.subGeneral ? this.sale.subGeneral.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Subtotal sin impuestos</label>
                                        <label style="margin: 0px 0px 0px auto;">
                                            {{ (this.sale.sub0 && this.sale.sub12) ? this.sale.sub0.plus(this.sale.sub12).toFixed(2) : (this.sale.sub0 ? this.sale.sub0.toFixed(2) : (this.sale.sub12 ? this.sale.sub12.toFixed(2) : '0.00')) }}
                                        </label>
                                    </div>
                                    <div v-if="saleHasIce" style="display: flex;">
                                        <label style="font-weight: bold">ICE</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.iceValue.toFixed(2) }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">IVA</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.tax ? this.sale.tax.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Descuento</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.discount ? this.sale.discount.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label style="font-weight: bold">Total</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.sale.total ? this.sale.total.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <small v-if="saleHasIce" style="display: block; margin-top: 8px; color: #888;">
                                        El IVA se calcula sobre la base más el ICE
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid formgrid" style="margin-top: 20px;">
                    <div class="col-12">
                        <div class="card">
                            <h5><b>Producto(s) / Servicio(s) a retornar</b></h5>
                            <Button icon="pi pi-plus" v-if="this.creditNote.id === null" class="p-button-rounded p-button-info mr-2 mb-2" style="position: absolute; top: 15px; right: 20px;" @click="displayProductDialog"/>
                            <DataTable :value="this.creditNote.items" editMode="cell" :scrollable="true" scrollHeight="400px" scrollDirection="both" class="mt-3 editable-cells-table">
                                <Column field="amount" header="Cantidad" :style="{width: '12.5%','min-width':'30px'}">
                                    <template #editor="{data, field}" v-if="this.creditNote.id === null">
                                        <InputText v-model="data[field]" type="number" autofocus :disabled="this.creditNote.id !== null" @change="onItemChanged(data)" />
                                    </template>
                                </Column>
                                <Column field="product" header="Descr." :style="{width: '45%','min-width':'100px'}"></Column>
                                <Column field="hasTax" header="IVA" :sortable="true" :style="{width: '12.5%','min-width':'30px'}">
                                    <template #body="slotProps">
                                        <span class="p-column-title">IVA</span>
                                        {{slotProps.data.hasTax ? "SI" : "NO"}}
                                    </template>
                                </Column>
                                <Column field="unitPrice" header="Precio Unit." :style="{width: '12.5%','min-width':'40px'}">
                                    <template #body="slotProps">
                                        {{ formatUnitPrice(slotProps.data.unitPrice) }}
                                    </template>
                                </Column>
                                <Column field="totalPrice" header="Precio Final" :style="{width: '12.5%','min-width':'40px'}">
                                    <template #body="slotProps">
                                        {{ (slotProps.data.amount && slotProps.data.unitPrice) ? slotProps.data.amount.times(slotProps.data.unitPrice).times(slotProps.data.discount.times(-1).plus(1)).toFixed(2) : '0.00' }}
                                    </template>
                                </Column>
                                <Column :exportable="false" :style="{width: '5%','min-width':'60px'}">
                                    <template #body="item" v-if="this.creditNote.id === null">
                                        <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text mr-2 mb-2"  @click="onItemDeleted(item)"/>
                                    </template>
                                </Column>
                            </DataTable>
                            <h5><b>Motivo de retorno</b></h5>
                            <InputText v-model="this.creditNote.reason" id="reason" type="text" :disabled="this.creditNote.id !== null" placeholder="Escriba el motivo de devolución del producto / servicio"/>
                        </div>
                    </div>
                </div>

                <div class="grid formgrid" style="margin-top: 20px;">
                    <div class="col-12">
                        <div class="card">
                            <h5><b>Valores de Nota de Crédito</b></h5>
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-6">
                                    <div style="margin-top: 10px;">
                                        <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                            <label style="margin: 0px;"><b>Secuencial</b></label><br>
                                            <label style="margin: 0px; font-weight: 300;">{{ (this.creditNote.edoc !== null) ? this.creditNote.edoc.sequence : "-" }}</label>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                            <label style="margin: 0px;"><b>Fecha Emisión</b></label><br>
                                            <label style="margin: 0px; font-weight: 300;">{{ (this.creditNote.edoc !== null && this.creditNote.edoc.sentAt !== null) ? this.creditNote.edoc.sentAt.toLocaleDateString("es-ES") : "-" }}</label>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                            <label style="margin: 0px;"><b>Fecha Autorización</b></label><br>
                                            <label style="margin: 0px; font-weight: 300;">{{ (this.creditNote.edoc !== null && this.creditNote.edoc.authorizedAt !== null) ? this.creditNote.edoc.authorizedAt.toLocaleDateString("es-ES") : "-" }}</label>
                                        </div>
                                        <div class="col-12 mb-2 lg:col-12 lg:mb-0">
                                            <label style="margin: 0px;"><b>Código de acceso</b></label><br>
                                            <label style="margin: 0px; font-weight: 300; max-width: 90%;">{{ (this.creditNote.edoc !== null) ? this.creditNote.edoc.accessCode : "-" }}</label>
                                        </div>
                                        <!-- Canje: el saldo a favor ya pagó otra venta. Mientras esté
                                             canjeada no se puede anular (lo rechaza el backend). -->
                                        <div class="col-12 mb-2 lg:col-12 lg:mb-0" v-if="this.creditNote.isRedeemed">
                                            <div class="flex align-items-start mt-3 p-3" style="background-color: var(--blue-50); border-left: 4px solid var(--blue-500); border-radius: 4px;">
                                                <i class="pi pi-ticket mr-2 mt-1" style="color: var(--blue-700)" />
                                                <div style="font-size: 0.9rem;">
                                                    {{ this.creditNote.redemptionReadable }}. Para anular la nota,
                                                    anula primero esa venta: eso la libera.
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Desenlace de la anulacion, no un cartel fijo: el texto y el color
                                             salen de annulmentStatus (ver models/edocument.js). Antes decia
                                             siempre "debe ser anulada en el portal del SRI" con solo mirar
                                             nulled+received, y eso mentia justo cuando el SRI aceptaba la
                                             solicitud. Lo que esta EN CURSO no sale aca. -->
                                        <div class="col-12 mb-2 lg:col-12 lg:mb-0" v-if="this.creditNote.edoc !== null && this.creditNote.edoc.annulmentNotice !== null">
                                            <div class="flex align-items-start mt-3 p-3"
                                                 :style="`background-color: var(--${this.creditNote.edoc.annulmentNotice.color}-50); border-left: 4px solid var(--${this.creditNote.edoc.annulmentNotice.color}-500); border-radius: 4px; --notice-accent: var(--${this.creditNote.edoc.annulmentNotice.color}-500); --notice-accent-strong: var(--${this.creditNote.edoc.annulmentNotice.color}-700);`">
                                                <i class="pi mr-2 mt-1" :class="this.creditNote.edoc.annulmentNotice.icon"
                                                   :style="`color: var(--${this.creditNote.edoc.annulmentNotice.color}-700)`" />
                                                <div style="flex: 1; min-width: 0;">
                                                <div style="font-size: 0.9rem;">{{ this.creditNote.edoc.annulmentNotice.title }}</div>
                                                <div v-if="this.creditNote.edoc.annulmentNotice.detail"
                                                     style="font-size: 0.82rem; color: var(--text-color-secondary); margin-top: 0.15rem;">{{ this.creditNote.edoc.annulmentNotice.detail }}</div>
                                                <!-- La accion la declara el aviso (Reportar / Consultar estado):
                                                     el modelo decide que se puede hacer en cada estado. -->
                                                <Button v-if="this.creditNote.edoc.annulmentNotice.action"
                                                        :label="this.creditNote.edoc.annulmentNotice.action.label"
                                                        :icon="this.creditNote.edoc.annulmentNotice.action.icon"
                                                        class="p-button-sm annulmentNoticeAction mt-2"
                                                        :disabled="annulmentInProgress"
                                                        @click="onAnnulmentAction(this.creditNote.edoc.annulmentNotice.action.name)" />
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-6 saleInformationContainer">
                                    <div style="display: flex;">
                                        <label>Subtotal 0%</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.creditNote.base0 ? this.creditNote.base0.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label>Subtotal 5%</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.creditNote.sub5 ? this.creditNote.sub5.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label>{{ this.creditNote.subGeneralLabel }}</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.creditNote.subGeneral ? this.creditNote.subGeneral.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label>Subtotal sin impuestos</label>
                                        <label style="margin: 0px 0px 0px auto;">
                                            {{ (this.creditNote.base0 && this.creditNote.base12) ? this.creditNote.base0.plus(this.creditNote.base12).toFixed(2) : '0.00' }}
                                        </label>
                                    </div>
                                    <div v-if="creditNoteHasIce" style="display: flex;">
                                        <label>ICE</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.creditNote.iceValue.toFixed(2) }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label>IVA</label>
                                        <label style="margin: 0px 0px 0px auto;">{{ this.creditNote.tax ? this.creditNote.tax.toFixed(2) : '0.00' }}</label>
                                    </div>
                                    <div style="display: flex;">
                                        <label>Total</label>
                                        <label style="margin: 0px 0px 0px auto;">
                                            {{ this.creditNote.total.toFixed(2)}}
                                        </label>
                                    </div>
                                    <small v-if="creditNoteHasIce" style="display: block; margin-top: 8px; color: #888;">
                                        El IVA se calcula sobre la base más el ICE
                                    </small>
                                </div>

                                <div class="field col-12 md:col-12 saleFormButtonContainer" style="margin-top: 35px;" v-show="this.creditNote.edoc === null || this.creditNote.edoc.nulled === false">
                                    <Button label="Limpiar" v-show="showClearButton" class="p-button-raised p-button-danger mr-2 mb-2" style="max-width: 170px" @click="onClearFields"/>
                                    <Button label="Anular" v-show="showDeleteButton" class="p-button-raised p-button-danger mr-2 mb-2" style="max-width: 170px" @click="displayDeleteConfirmation(true)"/>
                                    <div style="margin-left: auto;"></div>
                                    <Button label="Guardar" v-show="showSaveButton" :loading="loadingSaveButton" class="p-button-raised p-button-success mr-2 mb-2" style="max-width: 170px" @click="saveCreditNote()"/>
                                    <Button label="Generar" v-show="showCreateEDOCButton" :loading="loadingCreateEDOCButton" class="p-button-raised p-button-success mr-2 mb-2" style="max-width: 220px;" @click="attemptToCreateCreditNote()"/>
                                    <Menu ref="menu" :model="downloadOptions" :popup="true" style="width: auto; max-width: 170px;">
                                        <template #item="{item}">
                                            <Button type="button" :label="item.label" :icon="item.icon" class="menuButton mr-2 mb-2" :loading="loadingDownloadButton" @click="downloadCreditNote(item.name)"/>
                                        </template>
                                    </Menu>
                                    <Button type="button" label="Descargar" icon="pi pi-angle-down" v-show="showDownloadButton" class="p-button-raised p-button-success mr-2 mb-2" @click="toggleDownloadMenu" style="width: auto; width: 170px;"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Dialog header="Advertencia" v-model:visible="showSubscriptionDialog" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                    <p class="line-height-3 m-0">
                        {{ this.error.title }}<br>
                        {{ this.error.mensaje }}<br>
                        {{ this.error.informacionAdicional }}
                    </p>
                    <template #footer>
                        <Button label="Cerrar" @click="closeSubscriptionDialog" class="p-button-secondary mr-2 mb-2"/>
                        <Button label="Ver suscripción" @click="redirectToSubscription" class="p-button-info mr-2 mb-2"/>
                    </template>
                </Dialog>

                <Dialog :header="annulmentExpired ? 'No se puede anular' : 'Confirmación'" v-model:visible="showDeleteConfirmation" :style="{width: annulmentExpired ? '480px' : '420px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                    <!-- Fuera del plazo del SRI no se anula: el mensaje (y la guarda que lo
                         respalda) vienen del backend, ver EDocument.annulmentWindowClosedMessage. -->
                    <div v-if="creditNote.edoc && creditNote.edoc.annulmentExpired" class="flex align-items-start">
                        <i class="pi pi-ban mr-3" style="font-size: 2rem; color: var(--red-500)" />
                        <span>{{ creditNote.edoc.annulmentExpiredMessage }}</span>
                    </div>
                    <template v-else>
                        <div class="flex align-items-center justify-content-center">
                            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                            <span>¿Está seguro de anular esta nota de crédito?</span>
                        </div>
                        <!-- El cliente tiene que aceptar la anulacion: decirlo antes evita
                             la sorpresa de que la nota siga vigente despues de anular. -->
                        <div v-if="creditNote.edoc && creditNote.edoc.authorized" class="mt-3 p-3"
                             style="background-color: var(--blue-50); border-left: 4px solid var(--blue-500); border-radius: 4px; font-size: 0.9rem;">
                            Se enviará la solicitud al SRI. El cliente tendrá 5 días
                            hábiles para aceptarla; hasta entonces la nota de crédito
                            sigue siendo válida.
                        </div>
                    </template>
                    <template #footer>
                        <Button v-if="annulmentExpired" label="Entendido" @click="displayDeleteConfirmation(false)" class="p-button-secondary mr-2 mb-2" autofocus/>
                        <template v-else>
                            <Button label="No" @click="displayDeleteConfirmation(false)" class="p-button-secondary mr-2 mb-2"/>
                            <Button label="Sí" :loading="loadingDeleteButton" @click="deleteCreditNote()" class="p-button-warning mr-2 mb-2" autofocus />
                        </template>
                    </template>
                </Dialog>

                <!-- Sin credenciales del portal no se le puede informar la anulacion al
                     SRI (ver saleForm.vue): al ANULAR se ofrece anular sin reportar; al
                     REPORTAR una que ya quedo solo aca, el unico camino es cargarlas. -->
                <Dialog header="Credenciales del SRI no registradas" v-model:visible="showSriCredentialsDialog" :style="{width: '520px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                    <div class="flex align-items-start">
                        <i class="pi pi-info-circle mr-3 mt-1" style="font-size: 2rem; color: var(--blue-500)" />
                        <div v-if="annulmentUnreported">
                            <p class="mb-2">
                                Esta nota de crédito ya está anulada en Contablus, pero
                                <strong>para el SRI sigue vigente</strong>.
                            </p>
                            <p class="mb-0">
                                Registra las credenciales del portal <strong>SRI en línea</strong>
                                y Contablus se encargará de informar la anulación y de dar
                                seguimiento al estado de la solicitud.
                            </p>
                            <p v-if="!canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                Pídele a un administrador que las registre en Negocio.
                            </p>
                        </div>
                        <div v-else>
                            <p class="mb-2">
                                Para anular el comprobante ante el SRI de forma automática,
                                el negocio necesita tener registradas sus credenciales del
                                portal <strong>SRI en línea</strong>.
                            </p>
                            <p class="mb-0" style="font-size: 0.9rem; color: var(--orange-700);">
                                Si continúas sin reportar, la nota de crédito quedará anulada
                                en Contablus pero <strong>para el SRI seguirá vigente</strong>.
                                Tendrás que solicitar la anulación desde el portal; Contablus
                                la detectará sola.
                            </p>
                            <p v-if="!canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                Pídele a un administrador que las registre en Negocio.
                            </p>
                        </div>
                    </div>
                    <template #footer>
                        <Button :label="(annulmentUnreported && !canEditBusiness) ? 'Entendido' : 'Cancelar'" @click="showSriCredentialsDialog = false" class="p-button-secondary mr-2 mb-2"/>
                        <Button v-if="!annulmentUnreported" label="Anular sin reportar" icon="pi pi-exclamation-triangle" @click="deleteCreditNote(false)" class="p-button-warning mr-2 mb-2"/>
                        <Button v-if="canEditBusiness" label="Registrar credenciales" icon="pi pi-external-link" @click="goToSriCredentials" class="p-button-info mr-2 mb-2" autofocus/>
                    </template>
                </Dialog>

                <!-- Desenlace de la anulacion (ver saleForm.vue): Dialog y no toast, porque
                     el de "esperando al cliente" explica que la nota SIGUE VALIDA. -->
                <Dialog :header="annulmentOutcome ? annulmentOutcome.title : ''"
                        v-model:visible="showAnnulmentOutcome"
                        :style="{width: '460px'}" :breakpoints="{'640px': '92vw'}" :modal="true">
                    <div v-if="annulmentOutcome !== null" class="flex align-items-start">
                        <i class="pi mr-3" :class="annulmentOutcome.icon"
                           :style="`font-size: 2rem; color: var(--${annulmentOutcome.color}-500)`" />
                        <div style="min-width: 0;">
                            <span style="line-height: 1.5; overflow-wrap: anywhere;">{{ annulmentOutcome.message }}</span>
                            <p v-if="annulmentOutcome.action === 'sriCredentials' && !canEditBusiness" class="mt-2 mb-0" style="font-size: 0.85rem; color: var(--text-color-secondary);">
                                Pídele a un administrador que las registre en Negocio.
                            </p>
                        </div>
                    </div>
                    <template #footer>
                        <Button label="Entendido" @click="showAnnulmentOutcome = false"
                                class="p-button-secondary mr-2 mb-2" autofocus />
                        <Button v-if="annulmentOutcome !== null && annulmentOutcome.action === 'sriCredentials' && canEditBusiness"
                                label="Ir a Negocio" icon="pi pi-external-link" @click="goToSriCredentials"
                                class="p-button-info mr-2 mb-2" />
                    </template>
                </Dialog>

                <Dialog v-model:visible="showProductDialog" :style="{'max-width': '550px', width: '90%'}" header="Seleccione Producto / Servicio" :modal="true" class="p-fluid">
                    <div class="grid formgrid">
                        <DataTable :value="creditableSaleItems" selectionMode="single" editMode="cell" :scrollable="true" scrollHeight="500px" scrollDirection="both" class="mt-2 editable-cells-table" :style="{width: '100%'}" @rowSelect="onAddProduct">
                            <template #empty>Esta factura ya está acreditada por completo.</template>
                            <Column field="amount" header="Cantidad" :style="{width: '16.66%','min-width':'100px'}"></Column>
                            <Column header="Por acreditar" :style="{width: '16.66%','min-width':'100px'}">
                                <template #body="slotProps">
                                    {{ slotProps.data.creditable !== null ? slotProps.data.creditable.toString() : slotProps.data.amount.toString() }}
                                </template>
                            </Column>
                            <Column field="product" header="Descr." :style="{width: '50%','min-width':'100px'}"></Column>
                            <Column field="unitPrice" header="Precio Unit." :style="{width: '16.66%','min-width':'40px'}">
                                <template #body="slotProps">
                                    {{ slotProps.data.unitPrice ? slotProps.data.unitPrice.toFixed(2) : '0.00' }}
                                </template>
                            </Column>
                            <Column field="totalPrice" header="Precio Final" :style="{width: '16.66%','min-width':'40px'}">
                                <template #body="slotProps">
                                    {{ slotProps.data.totalPrice ? slotProps.data.totalPrice.toFixed(2) : '0.00' }}
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                    <template #footer>
                        <Button label="Cancelar" class="p-button-secondary mr-2 mb-2" @click="this.showProductDialog=false"/>
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>

<script>

import { saveDownload } from '../../service/fileDownload';
import httpRequest from '../../service/httpRequest';
import Sale from '../../models/sale';
import CreditNote from '../../models/creditNote';
import Business from '../../models/business';
import EventBus from '@/AppEventBus';
import { showSriPendingToast, clearSriPendingToast } from '@/service/sriPendingToast';
import { certificateError } from '@/service/certificateError';
import SaleItem from '../../models/saleItem';
import Big from 'big.js';

export default {
	data() {
		return {
            creditNote: new CreditNote(),
            sale: new Sale(),

            // Show
            // showNewButton: false,
            showProductDialog: false,
            showClearButton: false,
            showSaveButton: false,
            showCreateEDOCButton: false,
            showDeleteButton: false,
            showDeleteConfirmation: false,

            // Anulacion ante el SRI (mismo flujo que venta y compra). Mientras dura
            // bloquea el boton del aviso; el desenlace llega por WebSocket.
            annulmentInProgress: false,
            showSriCredentialsDialog: false,
            showAnnulmentOutcome: false,
            annulmentOutcome: null,
            showDownloadButton: false,
            showSubscriptionDialog: false,

            // Errors
            cardBackgroundColor: 'white',
            emptyItemListError: false,
            error: {},

            // Loading
            loadingSaveButton: false,
            loadingDeleteButton: false,
            loadingDownloadButton: false,
            loadingCreateEDOCButton: false,

            // Download
            downloadOptions: [
                {
                    label: 'PDF',
                    name: 'pdf',
                    icon: 'pi pi-file-pdf'
                },
                {
                    label: 'XML',
                    name: 'xml',
                    icon: 'pi pi-file-excel'
                },
            ],
		}
	},
    async created() {
        window.scrollTo(0, 0);

        // Desenlace de la anulacion ante el SRI (ver onAnnulmentResult)
        EventBus.on('annulment_result', this.onAnnulmentResult);

        // Get credit note
        let id = this.$route.query.id;
        if (id !== null && id !== undefined) {
            let response = await httpRequest.getCreditNote(id);
            if (response.status == 200) {
                this.sale = new Sale(response.data.sale);
                this.creditNote = new CreditNote(response.data);
                this.setupUI();
            }
        } else {
            // Get sale
            let saleId = this.$route.query.saleId;
            if (saleId !== null && saleId !== undefined) {
                let response = await httpRequest.getSale(saleId, true);
                if (response.status == 200) {
                    this.sale = new Sale(response.data);
                    this.creditNote = new CreditNote();
                    // Cada línea entra con lo que le queda por acreditar, y la ya acreditada
                    // completa no entra. Copias: editar la nota no toca la venta del diálogo.
                    for (const saleItem of this.sale.items) {
                        if (saleItem.creditable !== null && saleItem.creditable.lte(0)) { continue }
                        this.creditNote.updateItems(this.creditableCopy(saleItem));
                    }
                    this.setupUI();
                }
            } else { this.setupUI(); }
        }
    },
    beforeUnmount() {
        EventBus.off('annulment_result', this.onAnnulmentResult);
        clearSriPendingToast(this.$toast);
    },
	computed: {
        // Sin credenciales del portal no se le puede informar la anulacion al SRI.
        hasSriCredentials() {
            const business = this.$store.getters.business;
            return !!(business && business.hasSriPortalCredentials);
        },
        // Cargarlas vive en Negocio, que es pantalla de administrador.
        canEditBusiness() {
            return this.$can('business');
        },
        // Ya anulada aca sin avisarle al SRI: decide la variante del aviso de
        // credenciales (sin "Anular sin reportar", que volveria a anular).
        annulmentUnreported() {
            return !!(this.creditNote && this.creditNote.edoc && this.creditNote.edoc.annulmentUnreported);
        },
        // Líneas de la venta que todavía se pueden acreditar (ver creditNoteCRUD).
        creditableSaleItems() {
            const items = (this.sale && this.sale.items) || [];
            return items.filter(item => item.creditable === null || item.creditable.gt(0));
        },
        // Factura a consumidor final: el SRI no admite notas de credito sobre ella
        // (ver models/sale.js). Solo importa mientras la nota no tenga comprobante.
        saleBlocksCreditNote() {
            return !!(this.sale && this.sale.id !== null && !this.sale.allowsCreditNote
                      && this.creditNote && this.creditNote.edoc === null);
        },
        // Paso el plazo del SRI para anular (ver models/edocument.js): el aviso de
        // anular frena antes de confirmar.
        annulmentExpired() {
            return !!(this.creditNote && this.creditNote.edoc && this.creditNote.edoc.annulmentExpired);
        },
        // La fila de ICE solo aparece si el documento lo lleva: a diferencia de
        // las tarifas de IVA (0% / 5% / general), que son buckets de la misma
        // base y se muestran siempre, el ICE es un impuesto aparte que la mayoría
        // de negocios nunca factura y en cero solo sería ruido.
        saleHasIce() {
            const ice = this.sale && this.sale.iceValue;
            return !!(ice && !ice.eq(0));
        },
        creditNoteHasIce() {
            const ice = this.creditNote && this.creditNote.iceValue;
            return !!(ice && !ice.eq(0));
        }
    },
	methods: {
        setupUI() {
            this.showClearButton = this.creditNote.id === null;
            // Solo una nota YA guardada se anula: sin comprobante (se guardo sin cuota,
            // el backend la borra) o con comprobante vigente y sin una solicitud de
            // anulacion en curso. Una nota nueva tampoco tiene comprobante, y no hay
            // nada que anular todavia.
            const edoc = this.creditNote.edoc;
            this.showDeleteButton = this.creditNote.id !== null
                && (edoc === null || (edoc.nulled === false && !edoc.annulmentInFlight));
            this.showSaveButton = this.creditNote.id === null && !this.saleBlocksCreditNote;
            this.showCreateEDOCButton = this.creditNote.id !== null && this.creditNote.edoc === null && !this.saleBlocksCreditNote;
            this.showDownloadButton = this.creditNote.edoc !== null  && !this.creditNote.edoc.nulled === true;
            this.cardBackgroundColor = (this.creditNote.edoc !== null && this.creditNote.edoc.nulled === true) ? "#ffc9c9" : "white";
        },
        parseItems(data) {
            this.creditNote.items = data.map(item => new SaleItem(item));
        },
        // Customer
        checkForm() {
            var error = null;
            var creditNoteTotal = parseFloat(this.creditNote.total).toFixed(2);
            var saleTotal = parseFloat(this.sale.total).toFixed(2);
			if (this.creditNote.items.length == 0) { error = "La nota de crédito debe contener uno o más productos / servicios." }
            else if (this.creditNote.reason == null || this.creditNote.reason === "") { error = "Por favor ingrese el motivo de la devolución del producto / servicio." }
            else if (parseFloat(creditNoteTotal) > parseFloat(saleTotal)) { error = "El total de la nota de crédito no puede exceder a $" + this.sale.total.toFixed(2) }
            else {
                // Lo vendido menos lo que ya acreditaron otras notas: el backend lo vuelve
                // a revisar al guardar (CreditNote.creationError).
                const over = this.creditNote.items.find(item =>
                    item.creditable !== null && item.creditable !== undefined && new Big(item.amount).gt(item.creditable));
                if (over) { error = `De «${over.product}» quedan ${over.creditable.toString()} por acreditar.` }
            }
			return error;
		},

        // Product
        displayProductDialog() {
            this.showProductDialog = true;
        },
        onAddProduct(data) {
            this.creditNote.updateItems(this.creditableCopy(data.data), false);
        },
        // Copia de la línea de la venta con la cantidad que le queda por acreditar.
        creditableCopy(saleItem) {
            let item = new SaleItem(saleItem);
            if (item.creditable !== null) { item.amount = item.creditable }
            return item;
        },
        onItemChanged(data) {
            let item = new SaleItem(data);
            this.creditNote.updateItems(item, false);
        },
        onItemDeleted(item) {
            this.creditNote.deleteItem(item.data);
        },

        // Credit Note
        toggleDownloadMenu(event) {
            this.$refs.menu.toggle(event);
        },
        onClearFields() {
            this.creditNote = new CreditNote();
        },
        async saveCreditNote() {
            let error = this.checkForm();
            if (error !== null) {
                this.$toast.add({severity:'error', summary: 'Alerta', detail: error, life: 5000});
            } else {
                // Enable loading mode
                this.loadingSaveButton = true;

                // Send request
                this.creditNote.saleId = this.sale.id;
                let response = await httpRequest.saveCreditNote(this.creditNote);

                // Disable loading mode
                this.loadingSaveButton = false;

                if (response.data !== undefined && response.data !== null) {
                    this.creditNote = new CreditNote(response.data);
                }

                if (response.status === 200) {
                    history.pushState(
                        {},
                        null,
                        this.$route.path + '?id=' + this.creditNote.id + '&saleId=' + this.sale.id
                    )
                    this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su nota de crédito ha sido guardada y reportada al SRI.', life: 3000});
                } else if (response.status === 602 || response.status === 604) {
                    // La firma o una dirección que el SRI exige no dejan emitir: la nota quedó guardada.
                    this.$toast.add({severity:'warn', summary: 'Nota de crédito guardada sin emitir', detail: certificateError(response, false).mensaje, life: 12000});
                } else if (response.status === 802) { 
                    this.error.title = (response.error === "NO_DOC") ? "Documentos electrónicos agotados" : "Suscripción no válida";
                    this.error.mensaje = "Su nota de crédito ha sido guardada por el momento. Para reportar su nota de crédito al SRI por favor renueve su suscripción."
                    this.showSubscriptionDialog = true;
                } else if (response.status === 422 && response.error) {
                    // Guardas del backend (p. ej. factura a consumidor final).
                    this.$toast.add({severity:'warn', summary: 'No se puede emitir', detail: response.error, life: 10000});
                } else {
                    this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
                }
                
                this.setupUI();
            }
        },
        async attemptToCreateCreditNote() {
            // Enable loading mode
            this.loadingSaveButton = true;

            // Send request
            let response = await httpRequest.attemptToCreateCreditNote(this.creditNote.id);

            // Disable loading mode
            this.loadingCreateEDOCButton = false;

            if (response.data !== undefined && response.data !== null) {
                this.creditNote = new CreditNote(response.data);
            }

            if (response.status === 200) {
                history.pushState(
                    {},
                    null,
                    this.$route.path + '?id=' + this.creditNote.id + '&saleId=' + this.sale.id
                )
                this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Su nota de crédito ha sido guardada y reportada al SRI.', life: 3000});
            } else if (response.status === 602 || response.status === 604) {
                // La firma o una dirección que el SRI exige no dejan emitir: la nota quedó guardada.
                this.$toast.add({severity:'warn', summary: 'Nota de crédito guardada sin emitir', detail: certificateError(response, false).mensaje, life: 12000});
            } else if (response.status === 802) { 
                this.error.title = (response.error === "NO_DOC") ? "Documentos electrónicos agotados" : "Suscripción no válida";
                this.error.mensaje = "Su nota de crédito ha sido guardada por el momento. Para reportar su nota de crédito al SRI por favor renueve su suscripción."
                this.showSubscriptionDialog = true;
            } else if (response.status === 422 && response.error) {
                // Guardas del backend (p. ej. factura a consumidor final).
                this.$toast.add({severity:'warn', summary: 'No se puede emitir', detail: response.error, life: 10000});
            } else {
                this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
            }

            this.setupUI();
        },
        async deleteCreditNote(reportToSri = true) {
            // Autorizada y sin credenciales del portal: no hay forma de informarle la
            // anulacion al SRI. Se pregunta antes (ver saleForm.vue).
            const edoc = this.creditNote.edoc;
            if (reportToSri && edoc && edoc.authorized && !(await this.refreshSriCredentials())) {
                this.showDeleteConfirmation = false;
                this.showSriCredentialsDialog = true;
                return;
            }

            this.showSriCredentialsDialog = false;
            this.loadingDeleteButton = true;
            let response = await httpRequest.deleteCreditNote(this.creditNote.id, reportToSri);
            this.showDeleteConfirmation = this.loadingDeleteButton = false;
            if (response.status === 200) {
                // Autorizada: se le pidio la anulacion al SRI. Nada se da por anulado
                // todavia; el desenlace llega por WebSocket.
                if (response.data !== null && response.data.async === true) {
                    this.annulmentInProgress = true;
                    showSriPendingToast(this.$toast, {summary: 'Anulación en curso', detail: response.data.message,
                        onTimeout: () => { this.annulmentInProgress = false; }});
                    await this.reloadCreditNote();
                    return;
                }
                if (response.data !== null) {
                    this.creditNote = new CreditNote(response.data);
                    this.setupUI();
                    const detail = this.creditNote.edoc && this.creditNote.edoc.annulmentUnreported
                        ? 'La nota de crédito quedó anulada en Contablus. Para el SRI sigue vigente hasta que solicites la anulación en el portal.'
                        : 'Su nota de crédito ha sido anulada.';
                    this.$toast.add({severity:'success', summary: 'Nota de crédito anulada', detail: detail, life: 8000});
                } else {
                    this.$router.push('/dashboard/nota-credito/crud');
                }
            } else if (response.status === 422 && response.error) {
                this.$toast.add({severity:'warn', summary: 'No se puede anular', detail: response.error, life: 10000});
            } else {
                this.$toast.add({severity:'error', summary: 'Error interno', detail: 'Hemos detectado un error, por favor intente nuevamente.', life: 3000});
            }
        },
        async reloadCreditNote() {
            let response = await httpRequest.getCreditNote(this.creditNote.id);
            if (response.status == 200) {
                this.sale = new Sale(response.data.sale);
                this.creditNote = new CreditNote(response.data);
                this.setupUI();
            }
        },
        // Una sola accion, la que el aviso declare (ver models/edocument.js).
        onAnnulmentAction(name) {
            if (name === 'report') { return this.reportAnnulmentToSri() }
            if (name === 'check') { return this.checkAnnulmentStatus() }
        },
        // Informa al SRI una anulacion que quedo solo en Contablus.
        async reportAnnulmentToSri() {
            if (!this.creditNote.edoc) { return }
            if (!(await this.refreshSriCredentials())) { this.showSriCredentialsDialog = true; return }
            this.annulmentInProgress = true;
            let response = await httpRequest.reportAnnulmentToSri(this.creditNote.edoc.id);
            if (response.status === 200 && response.data && response.data.async === true) {
                showSriPendingToast(this.$toast, {summary: 'Reportando al SRI', detail: response.data.message,
                    onTimeout: () => { this.annulmentInProgress = false; }});
                return;  // el resultado llega por WebSocket
            }
            this.annulmentInProgress = false;
            this.$toast.add({severity:'error', summary: 'No se pudo reportar',
                detail: response.error || 'Intenta de nuevo en un momento.', life: 10000});
        },
        async checkAnnulmentStatus() {
            if (!this.creditNote.edoc) { return }
            this.annulmentInProgress = true;
            let response = await httpRequest.checkAnnulmentStatus(this.creditNote.edoc.id);
            if (response.status === 200 && response.data && response.data.async === true) {
                showSriPendingToast(this.$toast, {summary: 'Consultando al SRI', detail: response.data.message,
                    onTimeout: () => { this.annulmentInProgress = false; }});
                return;  // el resultado llega por WebSocket
            }
            this.annulmentInProgress = false;
            if (response.status === 200) {
                await this.reloadCreditNote();
                this.setAnnulmentOutcome('Estado actualizado', 'pi-info-circle', 'blue',
                    (this.creditNote.edoc && this.creditNote.edoc.annulmentMessage) || 'El comprobante ya no tiene una anulación en curso.');
            } else if (response.status === 422 && response.error) {
                const missingCredentials = !!(response.data && response.data.reason === 'sriCredentialsMissing');
                this.setAnnulmentOutcome('Consulta al SRI', 'pi-info-circle', 'blue', response.error,
                    missingCredentials ? 'sriCredentials' : null);
            } else {
                this.$toast.add({severity:'error', summary: 'No se pudo consultar',
                    detail: response.error || 'Intenta de nuevo en un momento.', life: 8000});
            }
        },
        // El store NO se rehidrata entre pestañas (ver saleForm.vue): antes de
        // frenar por falta de credenciales se le pregunta al backend.
        async refreshSriCredentials() {
            if (this.hasSriCredentials) { return true }
            const response = await httpRequest.syncAccount();
            if (response.status === 200 && response.data && response.data.business) {
                await this.$store.dispatch('setBusiness', new Business(response.data.business));
            }
            return this.hasSriCredentials;
        },
        goToSriCredentials() {
            window.open('/dashboard/general/informacion-basica?focus=sri-portal', '_blank');
            this.showSriCredentialsDialog = false;
            this.showAnnulmentOutcome = false;
        },
        // `action` (opcional) agrega un boton al dialogo; hoy solo 'sriCredentials'.
        setAnnulmentOutcome(title, icon, color, message, action = null) {
            this.annulmentOutcome = {title, icon, color, message, action};
            this.showAnnulmentOutcome = true;
        },
        // Desenlace por WebSocket. En notas de credito lo normal es que quede
        // PENDIENTE esperando al cliente, no anulada.
        async onAnnulmentResult(data) {
            if (!data || !this.creditNote || !this.creditNote.edoc) { return }
            if (data.edocId !== this.creditNote.edoc.id) { return }
            clearSriPendingToast(this.$toast);

            this.annulmentInProgress = false;
            if (data.status !== 'ok') {
                this.setAnnulmentOutcome('No se pudo anular', 'pi-times-circle', 'red', data.message);
            } else if (data.state === 'accepted') {
                this.setAnnulmentOutcome('Comprobante anulado', 'pi-check-circle', 'green', data.message);
            } else {
                // El cliente tiene 5 dias habiles y hasta entonces la nota de credito
                // SIGUE SIENDO VALIDA. Es el desenlace que mas hay que leer.
                this.setAnnulmentOutcome('Esperando al cliente', 'pi-clock', 'orange', data.message);
            }
            await this.reloadCreditNote();
        },
        async downloadCreditNote(type) {
            this.loadingDownloadButton = true;
            try {
                const response = await httpRequest.downloadCreditNote(this.creditNote.id, type);
                await saveDownload(response, "nota_credito_" + this.creditNote.edoc.serial + "." + type, "application/" + type, this.$toast);
            } finally {
                this.loadingDownloadButton = false;
            }
        },
        displayDeleteConfirmation(show) {
            this.showDeleteConfirmation = show;
        },
        closeSubscriptionDialog() {
            this.showSubscriptionDialog = false;
        },
        redirectToSubscription() {
            this.showSubscriptionDialog = false;
            this.$router.push('/dashboard/general/suscripcion');
        },
        formatUnitPrice(price) {
            if (!price) return '0.00';
            let str = (typeof price.toString === 'function') ? price.toString() : new Big(price).toString();
            if (!str.includes('.')) return (typeof price.toFixed === 'function') ? price.toFixed(2) : new Big(price).toFixed(2);
            const decimals = str.split('.')[1];
            // Si hay decimales significativos, muestra hasta 4, si no, solo 2
            if (decimals.length > 2 && !/^0{2,}$/.test(decimals.slice(-2))) {
                return (typeof price.toFixed === 'function') ? parseFloat(price.toFixed(4)).toString() : parseFloat(new Big(price).toFixed(4)).toString();
            }
            return (typeof price.toFixed === 'function') ? price.toFixed(2) : new Big(price).toFixed(2);
        },
    }
}
</script>

<style scoped lang="scss">
    // Boton de accion del aviso de anulacion: toma el color del aviso (ver purchaseForm.vue).
    .annulmentNoticeAction {
        width: auto;
        background: transparent;
        color: var(--notice-accent-strong);
        border: 1px solid var(--notice-accent);
        font-weight: 600;
    }
    .annulmentNoticeAction:enabled:hover,
    .annulmentNoticeAction:enabled:focus {
        background: var(--notice-accent);
        border-color: var(--notice-accent);
        color: #fff;
        box-shadow: none;
    }
    .menuButton {
        width: 100%;
        background-color: white;
        border: 0px;
        color: darkgrey;
    }
    .menuButton:hover {
        background-color: gray;
    }

    @media screen and (max-width: 769px) {
        .number-textfield {
            width: 150px;
            height: 30px;
            font-size: 13px;;
        }
        .guideReceiptContainer {
            width: 100%; 
            display: block;
        }
        .receiptContainer {
            width: 100%;
            margin-right: 0px;
        }
        .receiptSerialContainer {
            width: 100%;
        }
        .saleFormButtonContainer {
            display: block;
        }
        .paymentContainer {
            display: initial;
        }
        .paymentContainer > div > h5 {
            margin: 10px 0 5px 0; 
        }
        .paymentSubcontainer {
            display: block;
        }
        .collectButton {
            margin-top: 10px;
            padding: 0px;
            width: 100%;
        }
    }
    @media screen and (min-width: 769px) {
        .number-textfield {
            margin: 0px 0px 10px auto;
            width: 100px;
            height: 30px;
            font-size: 15px;

        }
        .guideReceiptContainer {
            width: 100%; 
            display: flex;
        }
        .receiptContainer {
            width: 60%;
            margin-right: 20px;
        }
        .receiptSerialContainer {
            width: 40%;
        }
        .saleFormButtonContainer {
            display: flex;
        }
        .saleInformationContainer {
            padding-left: 50px;
        }
        .paymentContainer {
            display: flex;
            // height: 6rem;
        }
        .paymentContainer > div > h5 {
            margin-bottom: 5px; 
        }
        .paymentSubcontainer {
            display: flex;
        }
        .collectButton {
            margin-left: 10px;
        }
    }
</style>